import { gql } from "@apollo/client";

export const CREATE_INQUIRY = gql`
  mutation CreateFranchiseInquiry($input: FranchiseInquiryInput!) {
    createFranchiseInquiry(input: $input) {
      id
      fullName
    }
  }
`;